<template>
    <span>
        <router-link :to="url" class="mr-2">
            <span class="inline-block mr-1">
                <slot />
            </span>
            <i v-if="direction == 'desc' || direction == ''" class="sort-icon up">&#9650;</i>
            <i v-if="direction == 'asc' || direction == ''" class="sort-icon down">&#9660;</i>
        </router-link>
    </span>
</template>

<script>

import Url from '@/service/url'

export default {
    name: 'SortLink',

    props: {
        sortKey: {
            type: String
        }
    },

    data () {
        return {
            direction: ''
        }
    },

    computed: {
        url () {

            const url = new Url

            return {
                name: this.$route.name,
                params: this.$route.params,
                query: {
                    ...url.getQuery(),
                    sort: this.sortKey,
                    direction: this.direction ? this.direction : 'desc'
                }
            }
        }
    },

    watch: {
        '$route' () {
            this.direction = ''
            this.setDirection()
        }
    },

    mounted () {
        this.setDirection()
    },

    methods: {
        setDirection () {
            const url = new Url
            const query = url.getQuery()

            if (query.direction && query.sort == this.sortKey) {

                const direction = query.direction
                this.direction = direction == 'desc' ? 'asc' : 'desc'
            }
        }
    }
}
</script>

<style scoped>
.sort-icon {
    font-size: 14px;
}
</style>
